<div class="sheet-container">
  <div class="sheet-header">
    <span class="track-title">{{trackModel.title}}</span>
    <button mat-stroked-button	class="close-btn" (click)="close()">Close</button>
  </div>
  <!-- <button mat-stroked-button	class="close-btn" (click)="nextTrack()">Next</button> -->
<mat-tab-group animationDuration="0ms">
    <mat-tab label="Video">
      <ng-template matTabContent>
        <div *ngIf="trackModel.videoId" id="video-container">
          <app-video></app-video>
        </div>
        <div class="tab-text-content">
          <app-no-video *ngIf="!trackModel.videoId"></app-no-video>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Profile">
      <ng-template matTabContent>
        <div id='chart-container'>
          <ngx-charts-line-chart
          id="profile"
          [autoScale]="true"
          [xAxis]="true"
          [yAxis]= "true"
          [gradient]= "false"
          yAxisLabel="altitude (m)"
          showYAxisLabel="true"
          xAxisLabel="distance (km)"
          showXAxisLabel="true"
          [results]="trackModel.profile"></ngx-charts-line-chart>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Description">
        <div class="tab-text-content">
            {{trackModel.description}}
        </div>
    </mat-tab>
    <mat-tab label="Data">
      <ul class="data-list">
        <li>distance: {{trackModel.totalDistance | number:'1.1-2'}} km</li>
        <li>min. elevation: {{trackModel.minElevation | number:'1.0-0'}} m</li>
        <li>max. elevation: {{trackModel.maxElevation | number:'1.0-0'}} m</li>
      </ul>
      
      <mat-divider></mat-divider>
      <div class="download-area">
        <button mat-button color="primary" (click)="downloadGPX()">Download .gpx</button> 
      </div>
    </mat-tab>
  </mat-tab-group>
</div>